import { get as getProp, pick, uniqBy } from 'lodash';
import { put, takeLatest, call } from 'redux-saga/effects';
import {
  FETCH_EVENTS,
  CREATE_EVENT,
  FETCH_GAMES_FOR_EVENTS,
  FETCH_SINGLE_EVENT,
  UPDATE_EVENT,
  MARK_EVENT_FOR_DELETION,
  FETCH_EVENT_AUDIT_LOGS,
} from '../constants';

import { fetchEventsSuccess, fetchEventsFailure } from '../actions';
import {
  createEventFailure,
  createEventSuccess,
  fetchEventAuditLogsFailure,
  fetchEventAuditLogsSuccess,
  fetchGamesForEventsFailure,
  fetchGamesForEventsSuccess,
  fetchSingleEventFailure,
  fetchSingleEventSuccess,
  updateEventFailure,
  updateEventSuccess,
  markEventForDeletionSuccess,
  markEventForDeletionFailure,

} from '../actions/eventsActions';

const createEventsSagas = (api) => {
  function* fetchEventsSaga(action) {
    const {
      limit, offset, orderBy, sort, markedForDeletion,
    } = action.payload;

    let response;
    try {
      response = yield call(api.fetchEvents, {
        limit,
        offset,
        orderBy,
        sort,
        markedForDeletion,
      });

      const responseData = getProp(response, 'data.data', {
        count: 0,
        events: [],
        offset: 0,
      });

      yield put(fetchEventsSuccess({
        totalCount: responseData.count,
        events: responseData.events,
        offset: responseData.offset,
      }));
    } catch (error) {
      console.log('Fetch events error', error);
      yield put(fetchEventsFailure());
    }
  }

  function* watchFetchEvents() {
    yield takeLatest(FETCH_EVENTS, fetchEventsSaga);
  }

  function* fetchGamesForEventsSaga() {
    try {
      const response = yield call(api.fetchGames);
      const games = uniqBy(response.data, 'gameId').sort((a, b) => Number(a.gameId) - Number(b.gameId));

      yield put(fetchGamesForEventsSuccess({
        games,
      }));
    } catch (error) {
      console.log('Fetch games for events error', error);
      yield put(fetchGamesForEventsFailure());
    }
  }

  function* watchFetchGamesForEvents() {
    yield takeLatest(FETCH_GAMES_FOR_EVENTS, fetchGamesForEventsSaga);
  }

  function* createEventSaga({ payload }) {
    console.log('creating event', payload);
    try {
      yield call(api.createEvent, payload);

      yield put(createEventSuccess());
    } catch (error) {
      console.log('Create event error', error.response);
      yield put(createEventFailure({
        errorMessage: error.response.data.message,
      }));
      // yield put(fetchEventsFailure());
    }
  }

  function* watchCreateEvent() {
    yield takeLatest(CREATE_EVENT, createEventSaga);
  }

  function* updateEventSaga({ payload }) {
    const { event } = payload;
    try {
      const response = yield call(api.updateEvent, event);
      const updatedEvent = getProp(response, 'data.data.updatedEvent.0', {});

      yield put(updateEventSuccess({
        event: updatedEvent,
      }));
    } catch (error) {
      yield put(updateEventFailure());
    }
  }

  function* markEventForDeletionSaga({ payload }) {
    const { eventName } = payload;
    try {
      yield call(api.markEventForDeletion, eventName);
      yield put(markEventForDeletionSuccess());
    } catch (error) {
      yield put(markEventForDeletionFailure());
    }
  }

  function* watchUpdateEvent() {
    yield takeLatest(UPDATE_EVENT, updateEventSaga);
  }

  function* watchMarkEventForDeletion() {
    yield takeLatest(MARK_EVENT_FOR_DELETION, markEventForDeletionSaga);
  }

  function* fetchSingleEventSaga({ payload }) {
    try {
      const response = yield call(api.fetchEventById, payload.eventId);
      const event = getProp(response, 'data.data', {});
      yield put(fetchSingleEventSuccess({
        event,
      }));
    } catch (error) {
      console.log('Fetch single event error', error);
      yield put(fetchSingleEventFailure());
    }
  }

  function* watchFetchSingleEvent() {
    yield takeLatest(FETCH_SINGLE_EVENT, fetchSingleEventSaga);
  }

  function* fetchEventAuditLogsSaga({ payload }) {
    try {
      const params = {
        ...pick(payload, ['limit', 'offset', 'eventId', 'orderBy']),
      };
      const response = yield call(api.fetchEventLog, params);
      const { auditLogs, count, offset } = getProp(response, 'data.data', {
        auditLogs: [],
        count: 0,
        offset: 0,
      });

      yield put(fetchEventAuditLogsSuccess({
        auditLogs,
        totalCount: count,
        offset,
      }));
    } catch (error) {
      console.log('Fetch event audit logs error', error);
      yield put(fetchEventAuditLogsFailure());
    }
  }

  function* watchfetchEventAuditLogs() {
    yield takeLatest(FETCH_EVENT_AUDIT_LOGS, fetchEventAuditLogsSaga);
  }

  return {
    sagas: {
      fetchEventsSaga,
      watchFetchSingleEvent,
    },
    watchFetchEvents,
    watchCreateEvent,
    watchUpdateEvent,
    watchMarkEventForDeletion,
    watchFetchGamesForEvents,
    watchFetchSingleEvent,
    watchfetchEventAuditLogs,
  };
};

export default createEventsSagas;
